/*
  Amaya: "Cape Town, right now" line. Keeps the local time live, shows today's sunset,
  and (optionally) the current temperature and weather in Sea Point from Open-Meteo,
  fetched by the visitor's browser and cached 10 minutes in sessionStorage.
  Degrades quietly: no weather = no weather shown.
*/
const RAD = Math.PI / 180;
const DAY_MS = 86400000;
const TZ = 'Africa/Johannesburg';

function sunTimes(now, lat, lon) {
  // Standard sunrise equation, good to a minute or two.
  const jd = now / DAY_MS + 2440587.5;
  const n = Math.round(jd - 2451545.0 + 0.0008 + lon / 360);
  const jStar = n - lon / 360;
  const m = (357.5291 + 0.98560028 * jStar) % 360;
  const c = 1.9148 * Math.sin(m * RAD) + 0.02 * Math.sin(2 * m * RAD) + 0.0003 * Math.sin(3 * m * RAD);
  const lambda = (m + c + 180 + 102.9372) % 360;
  const jTransit = 2451545.0 + jStar + 0.0053 * Math.sin(m * RAD) - 0.0069 * Math.sin(2 * lambda * RAD);
  const delta = Math.asin(Math.sin(lambda * RAD) * Math.sin(23.4397 * RAD));
  const cosW = (Math.sin(-0.833 * RAD) - Math.sin(lat * RAD) * Math.sin(delta)) / (Math.cos(lat * RAD) * Math.cos(delta));
  const w = Math.acos(Math.max(-1, Math.min(1, cosW))) / RAD;
  const toMs = (j) => (j - 2440587.5) * DAY_MS;
  return { rise: toMs(jTransit - w / 360), set: toMs(jTransit + w / 360) };
}

function fmtTime(ms) {
  return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, hourCycle: 'h23', timeZone: TZ }).format(new Date(ms));
}

const WEATHER_WORDS = [
  [0, 'clear'], [1, 'mostly clear'], [2, 'some cloud'], [3, 'overcast'],
  [45, 'misty'], [48, 'misty'], [51, 'drizzle'], [53, 'drizzle'], [55, 'drizzle'],
  [61, 'light rain'], [63, 'rain'], [65, 'heavy rain'], [80, 'showers'], [81, 'showers'], [82, 'showers'],
  [95, 'thunder'], [96, 'thunder'], [99, 'thunder'],
];
function weatherWord(code) {
  const hit = WEATHER_WORDS.find(([c]) => c === code);
  return hit ? hit[1] : '';
}

class AmayaSunset extends HTMLElement {
  connectedCallback() {
    this.lat = parseFloat(this.dataset.lat || '-33.92');
    this.lon = parseFloat(this.dataset.lon || '18.38');
    this.els = {
      time: this.querySelector('[data-time]'),
      sunmeta: this.querySelector('[data-sunmeta]'),
      weather: this.querySelector('[data-weather]'),
    };
    this.tick();
    this.timer = setInterval(() => this.tick(), 30000);
    if (this.dataset.weather === 'true') this.loadWeather();
    this.onVisibility = () => { if (document.visibilityState === 'visible') this.tick(); };
    document.addEventListener('visibilitychange', this.onVisibility);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  tick() {
    const now = Date.now();
    const t = sunTimes(now, this.lat, this.lon);
    if (this.els.time) this.els.time.textContent = fmtTime(now);
    if (this.els.sunmeta) {
      let s;
      if (now < t.rise) s = 'Sunrise ' + fmtTime(t.rise);
      else if (now < t.set) s = 'Sunset ' + fmtTime(t.set);
      else s = 'Sunrise ' + fmtTime(sunTimes(now + DAY_MS, this.lat, this.lon).rise);
      this.els.sunmeta.textContent = s;
      this.els.sunmeta.hidden = false;
    }
  }

  async loadWeather() {
    const key = 'amaya-weather';
    let data = null;
    try {
      const cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.at < 10 * 60000) data = cached.data;
    } catch (e) { /* ignore */ }
    if (!data) {
      try {
        const url = 'https://api.open-meteo.com/v1/forecast?latitude=' + this.lat + '&longitude=' + this.lon +
          '&current=temperature_2m,weather_code&timezone=Africa%2FJohannesburg';
        const res = await fetch(url, { mode: 'cors', cache: 'no-store' });
        if (!res.ok) return;
        const json = await res.json();
        data = json && json.current ? json.current : null;
        if (data) { try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), data })); } catch (e) { /* ignore */ } }
      } catch (e) { return; }
    }
    if (!data || !this.els.weather) return;
    const temp = Math.round(data.temperature_2m);
    if (!Number.isFinite(temp)) return;
    const word = weatherWord(data.weather_code);
    this.els.weather.textContent = temp + '°' + (word ? ' and ' + word : '');
    this.els.weather.hidden = false;
  }
}

if (!customElements.get('amaya-sunset')) customElements.define('amaya-sunset', AmayaSunset);
